import { Stack } from '@mui/material';
import { ReactNode } from 'react';
import { BaseDialog } from '../../common/dialogs/BaseDialog';
import { DialogContent } from '@mui/material';
import { colors, Typography } from '@sweep-io/sweep-design';

export const AgentSettingsDialogLayout = ({
  isOpen,
  onClose,
  menuJsx,
  children,
}: {
  isOpen: boolean;
  onClose: (e: any) => void;
  menuJsx: ReactNode;
  children: ReactNode;
}) => {
  return (
    <BaseDialog
      open={isOpen}
      onClose={onClose}
      PaperProps={{ sx: { width: '1020px', height: '724px', maxHeight: '80vh' } }}
    >
      <DialogContent sx={{ padding: 0, display: 'flex' }}>
        <Stack
          sx={{
            height: '100%',
            flex: '0 0 220px',
            backgroundColor: colors.grey[100],
            padding: '8px',
            gap: '8px',
          }}
        >
          <Stack padding="0 8px" justifyContent="center" height="32px">
            <Typography variant="caption" color={colors.grey[700]}>
              Agent settings
            </Typography>
          </Stack>
          <Stack gap={1}>{menuJsx}</Stack>
        </Stack>
        <Stack flex={1} overflow="auto">
          {children}
        </Stack>
      </DialogContent>
    </BaseDialog>
  );
};
